
import api from "./axiosInstance";

export const fetchData = async (endpoint, params) => {
  try {
    const { data } = await api.get(endpoint, { params });
    return data;
  } catch (error) {
    if (
      error.code === "ECONNABORTED" ||
      (error.message && error.message.includes("timeout"))
    ) {
      console.error("API request timed out");
      throw new Error("Request timed out. Please try again.");
    }

    console.error("API request failed:", error?.message || error);
    throw error;
  }
};
